import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { invitationsApi, type InvitationDecision } from "@/lib/api";

/**
 * Undangan afiliasi yang menunggu keputusan coach. Sengaja tidak lama di-cache
 * (30 detik) supaya undangan baru dari merchant segera terlihat.
 */
export function useAffiliationInvitations() {
    return useQuery({
        queryKey: ["affiliation-invitations"],
        queryFn: ({ signal }) => invitationsApi.list(signal),
        staleTime: 30 * 1000,
    });
}

/**
 * Terima/tolak undangan. Setelah berhasil, data yang bergantung pada afiliasi
 * dimuat ulang (daftar afiliasi, profil, dashboard) supaya klub baru langsung
 * muncul di mana-mana.
 */
export function useDecideInvitation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, decision }: { id: string; decision: InvitationDecision }) =>
            invitationsApi.decide(id, decision),
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["affiliation-invitations"] }),
                queryClient.invalidateQueries({ queryKey: ["coach-affiliations"] }),
                queryClient.invalidateQueries({ queryKey: ["coach-profile"] }),
                queryClient.invalidateQueries({ queryKey: ["coach-dashboard"] }),
            ]);
        },
    });
}
